import { Component, OnInit, Input, ViewChild, OnChanges, ChangeDetectorRef } from '@angular/core';
import { ReportingService } from '../services/reporting.service';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { ExcelService } from '../services/excel.service';
import * as _ from 'lodash';
import moment from 'moment';
import { Table } from 'primeng/table';
import * as html2pdf from 'html2pdf.js';
import { HttpService } from '../../../services/http.service';
import { ConvertToHoursPipe } from '@shared/pipes/secondsToHours.pipe';
import { DatePipe } from '@angular/common';
import { MasterService } from '../../admin/masters/services/master.service';
import { SiteService } from '../../site/service/site.service';
import { CallTrackingInfo } from "@shared/interfaces/call_tracking";
import { CallDetailsUserInterface } from '@shared/interfaces/interfaces';
import { SummaryData } from '@shared/interfaces/call_tracking';
import { CallTrackingService } from '@shared/services/call-tracking.service';
import * as tooltipText from '@shared/text/tooltips.json';
import { ColumnDataTypes, ColumnHeader, PageHasTable } from '@shared/interfaces/tables';
import { TableGenericComponent } from '@shared/components/tables/table-generic/table-generic.component';
import { from, of } from 'rxjs';
import { catchError, concatMap, filter, toArray } from 'rxjs/operators';

@Component({
  selector: 'app-call-tracking-report',
  templateUrl: './call-tracking-report.component.html',
  styleUrls: ['./call-tracking-report.component.css'],
})
export class CallTrackingReportComponent implements OnInit, OnChanges, PageHasTable {
  loading = false;
  @Input() siteId: any = null;
  @Input() params: any = null;
  @ViewChild('dt') dt: Table;
  selectedLocationIds: any[] = [];
  selectedAdSourceIds: string[] = [];
  columnDataTypes ?: ColumnDataTypes;
  columnHeaders: ColumnHeader[];
  callTrackingInfo: CallTrackingInfo[];
  callTrackingSummaryData: SummaryData;
  isAudioPlay;
  reports;
  filterBy = {
    aD_Source: '',
    apptSet: '',
    location: '',
    missedOpp: '',
    mobile: '',
    prospect: '',
    result: '',
  };
  callSources;
  today = new Date();
  audio = new Audio();
  reportParams = {
    callSourceId: '',
    startDate: moment().subtract(1, 'months').startOf('month').format('MM/DD/YYYY'),
    endDate: moment(moment()).subtract(1, 'months').endOf('month').format('MM/DD/YYYY'),
    _startDate: moment().subtract(1, 'months').startOf('month').format('MM/DD/YY'),
    _endDate: moment(moment()).subtract(1, 'months').endOf('month').format('MM/DD/YY'),
    adSource: '',
    dateRange: [
      moment().subtract(1, 'months').startOf('month').toDate(),
      moment().subtract(1, 'months').endOf('month').toDate()
    ]
  };
  locationsData;
  selectedSorting = 'Location';
  adSources;
  ttText: any;
  filterChangeTimeout: any = null;

  @ViewChild('dt') table: TableGenericComponent;

  constructor(
    private reportingService: ReportingService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private masterService: MasterService,
    private siteService: SiteService,
    private httpService: HttpService,
    private toastrService: ToastrService,
    private excelService: ExcelService,
    private callTrackingService: CallTrackingService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnChanges() {
    if (this.params) {
      Object.assign(this.reportParams, this.params);
    }
    this.getAdSourceData();
    this.getLocationsData(this.siteId);
    this.getCallSourceDetails(this.reportParams);
    this.getConfiguredAdSources(this.siteId);
  }

  ngOnInit() {
    this.ttText = (tooltipText as any).default;
    this.getTableData();

  }

  convertTime(input) {
    return moment(input, 'HH:mm:ss').format('h:mm A');
  }

  /**
   * @deprecated Use the Phone pipe if possible
   *
   * @see {@link DatePipe#transform}
   * @param {string} phoneNumberString
   */
  formatPhoneNumber(phoneNumberString) {
    try {
      if (phoneNumberString != null) {
        phoneNumberString = phoneNumberString.replace(/-/g, '');
      }
      var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
      var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
      if (match) {
        var intlCode = (match[1] ? '+1 ' : '')
        return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
      }
    }
    catch (e) {
      return phoneNumberString;
    }

    return null;
  }

  getLocationsData(siteId) {
    const currentLocationIds = [...this.selectedLocationIds];
    
    this.reportingService.getCallTracking(siteId).subscribe(
      (res: any) => {
        if (res) {
          const groupedLocations = res.reduce((groupMap, location) => {
            if (groupMap.has(location.customerName)) {
              if (location.isActive) {
                groupMap.get(location.customerName).ids.push(location.id);
              }
            } else {
              if (location.isActive) {
                groupMap.set(location.customerName, { 
                  customerName: location.customerName, 
                  ids: [location.id],
                  region: location.region || 'Default'
                });
              }
            }

            return groupMap;
          }, new Map<string, { customerName: string, ids: string[], region?: string }>());

          this.locationsData = Array.from(groupedLocations.values());
          
          if (currentLocationIds.length > 0) {
            setTimeout(() => {
              this.selectedLocationIds = currentLocationIds;
              this.cdr.detectChanges();
            }, 0);
          }
        }
      },
      (err) => {
        this.httpService.openErrorPopup(err.error.message);
      }
    );
  }

  /**
   * Gets data for the tables and sets the column headers
   */
  getTableData(): void {
    this.columnDataTypes = {
      appointment_Set: 'yesNoUndetermined',
      audio_URL: 'audioLink',
      caller_Number: 'phone',
      callSourceDateTime: 'dateLong',
      duration: 'duration',
      localDate: 'dateLong',
      localTime: 'time',
    };

    this.columnHeaders = [
      { field: 'location', header: 'Practice / Location', width: 20 },
      { field: 'localDate', header: 'Call Date', filter: 'none' },
      { field: 'localTime', header: 'Call Time', filter: 'none', width: 7 },
      { field: 'duration', header: 'Duration', filter: 'none', width: 7 },
      { field: 'audio_URL', header: 'Audio', filter: 'none', width: 7 },
      { field: 'caller_Number', header: 'Caller Number' },
      { field: 'caller_name', header: 'Caller Name' },
      { field: 'aD_Source', header: 'Ad Source', filter: 'select' },
      { field: 'prospect_Non_Prospect', header: 'Lead Type', filter: 'select' },
      { field: 'appointment_Set', header: 'Appt. Set', filter: 'select' },
    ];
  }

  getCallSourceDetails(reportParams) {
    this.loading = true;
    
    this.reportingService.getMultipleCallSourceDetails(this.siteId, reportParams)
      .subscribe({
        next: (res: any) => {
          if (res) {
            this.setCallSourceData(res);
          }
          this.loading = false;
        },
        error: (err) => {
          console.error('Full Error Object:', err);
          
          const errorMessage = 
            err?.message || 
            err?.error?.message || 
            'Failed to retrieve call source details';
          
          this.toastrService.error(errorMessage, 'Error');
          
          this.loading = false;
        }
      });
  }

  private _selectedLocationNames: string[] = [];

  get locationNames(): string[] {
    return this.selectedLocationIds.map(location => 
      typeof location === 'object' && location.customerName ? location.customerName : String(location)
    );
  }

  /**
   * Submit filters and get filtered data - only called when Apply Filters button is clicked
   */
  submitFilters(): void {
    if (this.filterChangeTimeout) {
      clearTimeout(this.filterChangeTimeout);
      this.filterChangeTimeout = null;
    }
    
        const rawSelections = this.selectedLocationIds.map(item => 
      Array.isArray(item) ? [...item] : 
      (item.ids ? [...item.ids] : item)
    );
    
    const adSourceSelections = [...this.selectedAdSourceIds];
    
    this.loading = true;
    
    const filterCombinations = this.prepareFilterCombinations();
    
        if (filterCombinations.length === 0) {
      filterCombinations.push({
        ...this.reportParams,
        callSourceIds: '0',
        adSource: ''
      });
    }
    
    from(filterCombinations).pipe(
      concatMap(params => 
        this.reportingService.getMultipleCallSourceDetails(this.siteId, params).pipe(
          catchError(err => {
            console.error('Error in filter combination:', params, err);
            return of(null);
          })
        )
      ),
      filter(response => response !== null),
      toArray()
    ).subscribe({
      next: (responses) => {
        this.mergeFilterResponses(responses);
        
        setTimeout(() => {
          this.selectedLocationIds = rawSelections;
          this.selectedAdSourceIds = adSourceSelections;
          
          this.cdr.markForCheck();
          this.cdr.detectChanges();
        }, 100);
        
        this.loading = false;
      },
      error: (err) => {
        console.error('Error in filter submission:', err);
        this.httpService.openErrorPopup('Failed to retrieve call source details');
        
        setTimeout(() => {
          this.selectedLocationIds = rawSelections;
          this.selectedAdSourceIds = adSourceSelections;
          this.cdr.detectChanges();
        }, 100);
        
        this.loading = false;
      }
    });
  }

  restoreLocationSelections(): void {
    if (!this._selectedLocationNames || !this._selectedLocationNames.length || !this.locationsData) {
      return;
    }
    
    console.log('Attempting to restore locations:', this._selectedLocationNames);
    
    const matchedLocations = this.locationsData.filter(location => 
      this._selectedLocationNames.includes(location.customerName)
    );
    
    console.log('Found matching locations:', matchedLocations.map(l => l.customerName));
    
    this.selectedLocationIds = [...matchedLocations];
    
    this.cdr.detectChanges();
  }
  
  /**
   * Reset all filters to default values
   */resetFilters(): void {
    const currentDateRange = [...this.reportParams.dateRange];
  const currentStartDate = this.reportParams.startDate;
  const currentEndDate = this.reportParams.endDate;
  const current_StartDate = this.reportParams._startDate;
  const current_EndDate = this.reportParams._endDate;
  
    this.selectedLocationIds = [];
  this.selectedAdSourceIds = [];
  
    this.reportParams = {
    callSourceId: '0',
    startDate: currentStartDate,
    endDate: currentEndDate,
    _startDate: current_StartDate,
    _endDate: current_EndDate,
    adSource: '',
    dateRange: currentDateRange
  };
  
    this.filterBy = {
    aD_Source: '',
    apptSet: '',
    location: '',
    missedOpp: '',
    mobile: '',
    prospect: '',
    result: '',
  };
  
    this.getCallSourceDetails(this.reportParams);
}
  
  clearLocationFilter(): void {
    this.selectedLocationIds = [];
      }
  
  clearAdSourceFilter(): void {
    this.selectedAdSourceIds = [];
      }
  onLocationItemRemoved(locationId: any): void {
        this.selectedLocationIds = this.selectedLocationIds.filter(item => {
      if (typeof item === 'object' && item.ids) {
                return !item.ids.includes(locationId);
      } else if (Array.isArray(item)) {
                return !item.includes(locationId);
      }
            return item !== locationId;
    });
    
        if (this.selectedLocationIds.length === 0) {
      this.submitFilters();
    }
  }
  
  /**
   * Handle individual ad source item removal from dropdown
   * @param adSourceId The ad source to remove
   */
  onAdSourceItemRemoved(adSourceId: string): void {
    this.selectedAdSourceIds = this.selectedAdSourceIds.filter(id => id !== adSourceId);
    
        if (this.selectedAdSourceIds.length === 0) {
      this.submitFilters();
    }
  }
  prepareFilterCombinations(): any[] {
    const combinations: any[] = [];
    
    let processedLocationIds: string[] = [];
    
    if (this.selectedLocationIds && this.selectedLocationIds.length > 0) {
      this.selectedLocationIds.forEach(location => {
        if (typeof location === 'object' && location.ids) {
          processedLocationIds = [...processedLocationIds, ...location.ids];
        } else if (Array.isArray(location)) {
          processedLocationIds = [...processedLocationIds, ...location];
        } else {
          processedLocationIds.push(location.toString());
        }
      });
    }
    
    const locationsToFilter = processedLocationIds.length > 0 
      ? processedLocationIds 
      : ['0'];
    
    const adSourcesToFilter = this.selectedAdSourceIds.length > 0 
      ? this.selectedAdSourceIds 
      : [''];
    
    locationsToFilter.forEach(locationId => {
      adSourcesToFilter.forEach(adSource => {
        combinations.push({
          ...this.reportParams,
          callSourceIds: locationId.toString(),
          adSource: adSource
        });
      });
    });
    
    return combinations;
  }
  
  mergeFilterResponses(responses: any[]): void {
    const aggregatedReports = {
      leads: 0,
      qualifiedLeads: 0,
      bookableLeads: 0,
      appointmentSet: 0,
      missedOpp: 0,
      callSources: []
    };
    
    responses.forEach(response => {
      if (response) {
        aggregatedReports.leads += parseInt(response.leads || 0);
        aggregatedReports.qualifiedLeads += parseInt(response.qualifiedLeads || 0);
        aggregatedReports.bookableLeads += parseInt(response.bookableLeads || 0);
        aggregatedReports.appointmentSet += parseInt(response.appointmentSet || 0);
        aggregatedReports.missedOpp += parseInt(response.missedOpp || 0);
        
        if (response.callSources) {
          const uniqueSources = response.callSources.filter(
            newSource => !aggregatedReports.callSources.some(
              existingSource => this.areSourcesEqual(existingSource, newSource)
            )
          );
          aggregatedReports.callSources.push(...uniqueSources);
        }
      }
    });
    
    this.reports = aggregatedReports;
    this.callSources = aggregatedReports.callSources;
    
    this.resetPagination();
  }

  compareWith(item1: any, item2: any): boolean {
    if (Array.isArray(item1) && Array.isArray(item2)) {
      return JSON.stringify(item1.sort()) === JSON.stringify(item2.sort());
    }
    
    if (item1 && item1.ids && Array.isArray(item2)) {
      return JSON.stringify(item1.ids.sort()) === JSON.stringify(item2.sort());
    }
    
    if (item2 && item2.ids && Array.isArray(item1)) {
      return JSON.stringify(item2.ids.sort()) === JSON.stringify(item1.sort());
    }
    
    return false;
  }
 
  
  areSourcesEqual(source1: any, source2: any): boolean {
    return source1.caller_Number === source2.caller_Number &&
      source1.date === source2.date &&
      source1.localTime === source2.localTime;
  }

  setCallSourceData(res) {
    const currentLocationIds = JSON.parse(JSON.stringify(this.selectedLocationIds));
    const currentAdSourceIds = [...this.selectedAdSourceIds];
    
    this.reports = res;
    this.callSources = res["callSources"];
    
    setTimeout(() => {
      this.selectedLocationIds = currentLocationIds;
      this.selectedAdSourceIds = currentAdSourceIds;
      this.cdr.detectChanges();
    }, 100);
  }
  
  preserveSelections() {
    const currentLocationIds = JSON.parse(JSON.stringify(this.selectedLocationIds));
    const currentAdSourceIds = [...this.selectedAdSourceIds];
    
    setTimeout(() => {
      this.selectedLocationIds = currentLocationIds;
      this.selectedAdSourceIds = currentAdSourceIds;
      this.cdr.detectChanges();
    }, 100);
  }

  getConfiguredAdSources(siteId: string): void {
    const currentAdSourceIds = [...this.selectedAdSourceIds];
    
    this.siteService.getCallTracking(siteId).subscribe(
      (res: CallTrackingInfo[]) => {
        if (res) {
          const filteredAdSources = Array.from(
            new Set(
              res
                .filter((item) => item.isActive === true)
                .map((item) => item.adSource)
            )
          );
          
          this.adSources = this.adSources.filter(element =>
            filteredAdSources.some(str => element.name.includes(str))
          );
          
          if (currentAdSourceIds.length > 0) {
            setTimeout(() => {
              this.selectedAdSourceIds = currentAdSourceIds;
              this.cdr.detectChanges();
            }, 0);
          }
        }
      },
      (err) => {
        this.httpService.openErrorPopup(err.error.message);
      }
    );
  }

  onValueChange(event) {
    this.reportParams.startDate = moment(event[0]).format('MM/DD/YYYY');
    this.reportParams.endDate = moment(event[1]).format('MM/DD/YYYY');
    this.reportParams._startDate = moment(event[0]).format('MM/DD/YY');
    this.reportParams._endDate = moment(event[1]).format('MM/DD/YY');
    this.reportParams.dateRange = event;
    this.submitFilters();
  }

  applySorting(params, label) {
    this.selectedSorting = label;

    const topBar = document.getElementById('sortby');

    topBar.classList.remove('show');
  }

  playAudio(callSource, action) {
    _.forEach(this.reports.callSources, (source) => {
      source.isAudioPlay = false;
    });
    this.audio.pause();
    if (action == 'play') {
      this.audio = new Audio();
      this.audio.src = callSource.audio_URL;
      this.audio.load();
      this.audio.play();
      callSource.isAudioPlay = !callSource.isAudioPlay;
    }
  }

  getAdSourceData(){
    const currentAdSourceIds = [...this.selectedAdSourceIds];
    
    this.masterService.getMastersListById(45).subscribe((res: any) => {
      if (res) {
        this.adSources = res['masterList'];
        
        if (currentAdSourceIds.length > 0) {
          setTimeout(() => {
            this.selectedAdSourceIds = currentAdSourceIds;
            this.cdr.detectChanges();
          }, 0);
        }
      }
    },
    err => {
      this.httpService.openErrorPopup(err.error.message);
    });
  }

  downloadReport(report: string) {
    window.scroll(0,0);
    document.getElementById("downloadButton").style.display = 'none';
    var collapsedElements = document.getElementsByClassName('collapse');
    _.forEach(collapsedElements, (element) => {
      element.className += ' show';
    })
    var element = '<div style="padding: 20px;">' + document.getElementById('report').innerHTML + '<div class="listing call-track-overview"><div class="listing-heading"><h3 style="padding: 10px 27px;">Call Details</h3></div></div></div>';
    var opt = {
      margin: 0,
      filename: 'call-tracking.pdf',
      jsPDF: { unit: 'in', format: 'b3', orientation: 'portrait' },
      pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
    };
    let values = [];
    let keys = [
      'Practice/ Location',
      'Result',
      'Call Date/ Time',
      'Duration',
      'Audio',
      'Caller Number',
      'caller_name',
      'Ad Source',
      'Appt.Set',
      'Lead Type',
      'CS Lead Score'
    ];

    let tableData = this.getCallSourceData();
    _.forEach(tableData, (data) => {
      let value = _.values(data);
      values.push(value);
    })

    var output = 'save';
    if (report == 'print') {
      output = 'dataurlnewwindow';
    }
    var worker = html2pdf().from(element).set(opt);
    worker.toPdf().get('pdf').then((pdf) => {
      pdf.autoTable({
        headStyles: { fillColor: '#DCE0EB', textColor: '#4D4F5C' },
        head: [keys],
        body:
          values,
        columnStyles: {
          0: { minCellWidth: 1.4 },
          1: { minCellWidth: 1, textColor: '#1AA69A' },
          2: { minCellWidth: 1.2 },
          3: { minCellWidth: 1 },
          4: { minCellWidth: 2.2 },
          5: { minCellWidth: 1.5 },
          6: { minCellWidth: 1.5 },
          7: { minCellWidth: 1.2 },
          8: { minCellWidth: 1 },
          9: { minCellWidth: 1.5 },
          10: { minCellWidth: 1.5 }
        },
        startY: 5,
        margin: 0.2,
        startX: 0
      });
    }).output(output, 'call-tracking.pdf');
    document.getElementById("downloadButton").style.display = 'block';
  }

  getCallSourceData() {
    const convertToHoursPipeFilter = new ConvertToHoursPipe();
    let datePipeFilter = new DatePipe('en-US');
    let callSources = [];

    _.forEach(this.reports.callSources, (source) => {
      const obj = {
        'location': source.location,
        'result': source.result,
        'date_time': datePipeFilter.transform(source.localDate, 'MMMM d, y') + ' ' + this.convertTime(source.localTime),
        'duration': source.duration?convertToHoursPipeFilter.transform(source.duration):'',
        'audio': source.audio_URL,
        'callNumber': this.formatPhoneNumber(source.caller_Number),
        'caller_name': source.caller_name,
        'adSource': source.aD_Source,
        'apptSet': source.appointment_Set != "N/A" ? source.appointment_Set : source.missed_Opp,
        'prospect': source.prospect_Non_Prospect,
        'leadScore': source.leadScore
      };

      callSources.push(obj);
    });
    return callSources;
  }

  applyFilter(filterBy) {
    let filteredCallSource = this.reports.callSources;

    if (filterBy) {
      if (!_.isEmpty(filterBy.mobile)) {
        filteredCallSource = _.filter(filteredCallSource, (user) => {
          return _.includes(user['caller_Number'], filterBy.mobile);
        });
      }
      if (!_.isEmpty(filterBy.location)) {
        filteredCallSource = _.filter(filteredCallSource, (user) => {
          return _.includes(user['location'].toLowerCase(), filterBy.location.toLowerCase());
        });
      }
      if (!_.isEmpty(filterBy.result)) {
        filteredCallSource = _.filter(filteredCallSource, (user) => {
          return _.includes(user['result'].toLowerCase(), filterBy.result.toLowerCase());
        });
      }
      if (!_.isEmpty(filterBy.aD_Source)) {
        filteredCallSource = _.filter(filteredCallSource, (user) => {
          return _.includes(user['aD_Source'].toLowerCase(), filterBy.aD_Source.toLowerCase());
        });
      }
      if (!_.isEmpty(filterBy.prospect)) {
        filteredCallSource = _.filter(filteredCallSource, (user: CallDetailsUserInterface) => {
          return _.includes(
            user['prospect_Non_Prospect']?.toLowerCase(),
            filterBy.prospect.toLowerCase()
          );
        });
      }

      if (!_.isEmpty(filterBy.missedOpp)) {
        filteredCallSource = _.filter(filteredCallSource, (user) => {
          if (user['missed_Opp']) {
            return _.includes(user['missed_Opp'].toLowerCase(), filterBy.missedOpp.toLowerCase());
          }
          return false;
        });
      }

      if (!_.isEmpty(filterBy.apptSet)) {
        filteredCallSource = _.filter(filteredCallSource, (user) => {
          if (user['appointment_Set']) {
            return _.includes(
              user['appointment_Set'].toLowerCase(),
              filterBy.apptSet.toLowerCase()
            );
          }
          return false;
        });
      }

      this.callSources = filteredCallSource;

      this.resetPagination();
    }
  }

  public resetPagination() {
    if (this.dt) {
      this.dt.first = 0;
    }
  }
  
  convertSecondsToHumanReadable(seconds: number | null | undefined): string {
    if (seconds == null || isNaN(seconds)) {
      return '00:00:00';
    }

    const hours = Math.floor(seconds / 3600);
    const remainingSecondsAfterHours = seconds % 3600;
    const minutes = Math.floor(remainingSecondsAfterHours / 60);
    const remainingSeconds = remainingSecondsAfterHours % 60;

    const formattedHours = hours.toString().padStart(2, '0');
    const formattedMinutes = minutes.toString().padStart(2, '0');
    const formattedSeconds = remainingSeconds.toString().padStart(2, '0');

    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
  }
  
  exportToCsv() {
    const clonedData = this.callSources.map(callSource => {
      return {
        ...callSource,
        duration: this.convertSecondsToHumanReadable(callSource.duration)
      };
    });
    
    if (this.table) {
      this.table.data = clonedData;
      
      this.cdr.detectChanges();
    }
    
    this.table.exportCSV();
  }
  
  trackByFn(item: any) {
    return item.description; 
  }
}